<template>
	<BaseCard class="flex w-full items-center gap-4 p-5" alt>
		<div class="rounded-full bg-[#3F3F3F] p-2 *:h-7 *:w-7">
			<slot />
		</div>
		<div>
			<div class="text-label-primary text-sm font-medium capitalize">
				{{ primary }}
			</div>
			<div class="text-label-secondary mt-1 text-xs font-medium uppercase">
				{{ secondary }}
			</div>
		</div>
	</BaseCard>
</template>
<script setup lang="ts">
import BaseCard from './BaseCard.vue'

defineProps<{
	primary: string
	secondary: string
}>()
</script>
